import InputComponent from "../../components/elements/InputComponent";
import { IFormData } from "../../pages/seller-stepper/SellerStepper";
import UploderComponent from "../elements/UploderComponent";
import ButtonComponent from "../elements/ButtonComponent";
import MultiSellectCheckboxCom from "../elements/MultiSellectCheckboxCom";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";
import ControlledSelectElement from "../elements/ControlledSelectElement";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { motion } from "framer-motion";
import { BASE_URL_APP_VERSION, axiosPrivate } from "../../api/axios";
import customZ from "../../utils/setZodCustomMessages";
import moment from "jalali-moment";
import {
  idCardFieldSchema,
  notEmptyListField,
  notEmptyField,
  notEmptyDate,
  optonalStringInput,
} from "../../utils/customSchemas";
import { CalenderIcon } from "../Icons";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { childVariants } from "../../animation/RoutesAnimations";
import { useEffect, useState } from "react";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import _ from "lodash";
import {
  GET_FILE,
  STORE_STORE_LICENSE,
  STORE_JOB_CATEGORY_LIST,
  STORE_STORE_LICENSE_CREATE,
  STORE_STORE_LICENSE_UPDATE,
  STORE_PRODUCT_GROUP,
} from "../../api/apiClient";

export interface IdTitleOwnershipModel {
  license_type: string;
  name: string;
}

export interface IdTitleStateproductGroup {
  product_group_uid: string;
  name: string;
  is_active: boolean;
  state: boolean;
}

const ownershipTypeList: IdTitleOwnershipModel[] = [
  {
    license_type: "BUSINESS_LICENSE",
    name: "پروانه کسب حقیقی",
  },
  {
    license_type: "LEGAL_BUSINESS_LICENSE",
    name: "پروانه کسب حقوقی",
  },
  {
    license_type: "STEWARDSHIP_CARD",
    name: "کارت مباشرت",
  },
  {
    license_type: "COMPANY_CHARTER",
    name: "اساسنامه و روزنامه رسمی شرکت",
  },
];

const step3Schema = customZ
  .object({
    license_image: idCardFieldSchema,
    product_group_uid_list: notEmptyListField,
    job_category_uid: notEmptyField,
    store_uid: notEmptyField,
    license_type: notEmptyField,
    guild_id: notEmptyField,
    isic_code: optonalStringInput,
    date_of_issuance: notEmptyDate,
    expiry_date: notEmptyDate,
    national_code: optonalStringInput,
    tax_code: optonalStringInput,
  })
  .refine((data) => data.national_code || data.tax_code, {
    message: "At least one of 'national_code' or 'tax_code' must be provided.",
    path: ["nationalCodeTaxCode"],
  });

function SellerFormStep3({ formNo, setFormNo, storeUid }: any) {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(step3Schema)(data, context, options);
    },
  });

  const [activeField, setActiveField] = useState("national_code");

  const handleRadioChange = (field: any) => {
    setActiveField(field);
  };

  const access_token = localStorage.getItem("access_token");
  const [getData, setGetData] = useState<any>(undefined);
  const [formIsChanged, setFormIsChanged] = useState(false);
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);
  const [isImageDataLoading, setIsImageDataLoading] = useState(false);
  const [sendImageToApi, setSendImageToApi] = useState(false);
  const store_uid = localStorage.getItem("selected_store_uid");

  const [jobCategoryList, setJobCategoryList] = useState([
    {
      job_category_uid: "",
      name: "",
    },
  ]);
  const [isSubmiting, setIsSubmiting] = useState(false);
  const [storeLicenseInfo, getStoreLicenseInfo] = useState<any>(null);
  const [imageData, setImageData] = useState<any>(null);

  const fetchStoreLicense = async (store_uid: string) => {
    setIsLoadingContents(true);
    setIsSubmiting(true);
    setIsImageDataLoading(true);
    try {
      const response = await axiosPrivate.get(STORE_STORE_LICENSE(store_uid), {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },

        withCredentials: true,
      });
      if (response?.status >= 200 && response?.status < 400) {
        setIsSubmiting(false);
        getStoreLicenseInfo(response.data.data);
        setIsLoadingContents(false);
      } else {
        setIsSubmiting(false);
        setIsLoadingContents(false);

        console.error(
          "ERROR in acceptRules:",
          response.data || response.statusText
        );
      }
    } catch (error) {
      setIsImageDataLoading(false);

      setIsLoadingContents(false);
      setIsSubmiting(false);
      console.error("Error fetching job category:", error);
    }
  };

  const fetchJobCategory = async () => {
    setIsSubmiting(true);
    try {
      const response = await axiosPrivate.get(STORE_JOB_CATEGORY_LIST, {
        headers: {
          accept: "application/json",
          // prettier-ignore
          "Content-Type": "multipart/form-data",
        },

        withCredentials: true,
      });
      setIsSubmiting(false);
      setJobCategoryList(response?.data?.data.result);
    } catch (error) {
      console.error("Error fetching job category:", error);
    } finally {
      setIsLoadingContents(false);
    }
  };

  const fetchImage = async () => {
    setIsImageDataLoading(true);

    try {
      const response = await axiosPrivate.get(
        GET_FILE(storeLicenseInfo?.license_image),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );

      setImageData(response?.data?.data?.url);

      setIsImageDataLoading(false);
    } catch (error) {
      setIsImageDataLoading(false);

      console.error("Error fetching image data:", error);
    }
  };

  const onSubmitStep3: SubmitHandler<IFormData> = async (data: IFormData) => {
    setIsSubmiting(true);
    if (!storeLicenseInfo) {
      const formattedData = {
        ...data,
        isic_code: data?.isic_code ? data?.isic_code : " ",
        date_of_issuance:
          data?.date_of_issuance instanceof Date
            ? data.date_of_issuance.toISOString().split("T")[0]
            : data.date_of_issuance,
        expiry_date:
          data?.expiry_date instanceof Date
            ? data.expiry_date.toISOString().split("T")[0]
            : data.expiry_date,
        product_group_uid_list: data.product_group_uid_list.join(","),
      };

      try {
        const response = await axiosPrivate.post(
          STORE_STORE_LICENSE_CREATE,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );
        setFormNo(formNo + 1);

        if (response?.status >= 200 && response?.status < 300) {
          setIsSubmiting(false);
        } else {
          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        setIsSubmiting(false);
      }
    } else {
      if (formIsChanged) {
        const formattedData = {
          ...data,
          isic_code: data?.isic_code ? data?.isic_code : " ",
          date_of_issuance:
            data?.date_of_issuance instanceof Date
              ? data.date_of_issuance.toISOString().split("T")[0]
              : data.date_of_issuance,
          expiry_date:
            data?.expiry_date instanceof Date
              ? data.expiry_date.toISOString().split("T")[0]
              : data.expiry_date,
          product_group_uid_list: data.product_group_uid_list.join(","),
          license_image: sendImageToApi ? data.license_image : null,
        };

        try {
          const response = await axiosPrivate.put(
            STORE_STORE_LICENSE_UPDATE(store_uid ? store_uid : data.store_uid),
            formattedData,
            {
              headers: {
                // prettier-ignore
                "accept": "application/json",
                // prettier-ignore
                "Authorization": `Bearer ${access_token}`,
                "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
            }
          );
          setFormNo(formNo + 1);

          if (response?.status >= 200 && response?.status < 300) {
            setIsSubmiting(false);
          } else {
            console.error(
              "ERROR in acceptRules:",
              response.data || response.statusText
            );
          }
        } catch (error) {
          console.error("An unexpected error occurred:", error);
          setIsSubmiting(false);
        }
      } else {
        setFormNo(formNo + 1);
      }
    }
  };

  useEffect(() => {
    setValue("store_uid", store_uid ? store_uid : storeUid.store_uid);
    setValue(
      "product_group_uid_list",
      storeLicenseInfo?.product_group_uid_list
    );
    setValue(
      "date_of_issuance",
      storeLicenseInfo?.date_of_issuance.replace(/\//g, "-")
    );
    setValue("expiry_date", storeLicenseInfo?.expiry_date.replace(/\//g, "-"));
    setValue(
      "job_category_uid",
      storeLicenseInfo?.job_category.job_category_uid
    );
    setValue("license_type", storeLicenseInfo?.license_type);
    setValue("guild_id", storeLicenseInfo?.guild_id);
    storeLicenseInfo?.isic_code !== null &&
      setValue("isic_code", storeLicenseInfo?.isic_code);
    storeLicenseInfo?.national_code !== null &&
      setValue("national_code", storeLicenseInfo?.national_code);
    storeLicenseInfo?.tax_code !== null &&
      setValue("tax_code", storeLicenseInfo?.tax_code);
    setValue("license_image", storeLicenseInfo?.license_image);
  }, [storeLicenseInfo]);

  useEffect(() => {
    if (storeLicenseInfo?.license_image) {
      fetchImage();
    }
  }, [storeLicenseInfo?.license_image]);

  useEffect(() => {
    setValue("store_uid", store_uid ? store_uid : storeUid.store_uid);
    fetchJobCategory();
    fetchStoreLicense(store_uid ? store_uid : storeUid.store_uid);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const getLicenseStore = async () => {
    setIsLoadingContents(true);
    try {
      const response = await axiosPrivate.get(
        STORE_STORE_LICENSE(store_uid),

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      if (response?.status >= 200 && response?.status < 300) {
        getStoreLicenseInfo(response?.data?.data);
        setIsLoadingContents(false);
      } else {
        setIsLoadingContents(false);
      }
    } catch (error) {
      setIsLoadingContents(false);
    }
  };

  useEffect(() => {
    getLicenseStore();
  }, []);

  function CompareJSON(json1: any, json2: any) {
    var isSame = true;
    var json1Keys = Object.keys(json1);
    for (let i = 0; i < Object.keys(json1).length; i++) {
      if (!_.isEqual(json1[json1Keys[i]], json2[json1Keys[i]])) {
        isSame = false;
      }
    }
    return isSame;
  }

  useEffect(() => {
    if (
      getData === undefined &&
      storeLicenseInfo !== null &&
      imageData !== null
    ) {
      setGetData(watch());
    } else if (getData !== undefined) {
      setFormIsChanged(!CompareJSON(getData, watch()));
    }
  }, [watch(), storeLicenseInfo]);

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          onSubmit={handleSubmit(onSubmitStep3)}
          className="flex flex-col flex-1 gap-12  rounded-md shadow-md pb-20"
        >
          <div className="lg:flex  flex-1 lg:flex-auto gap-12  rounded-md shadow-md ">
            <div className="basis-1/2 md:mr-10 mr-2">
              <div className="flex gap-6 flex-col">
                <ControlledSelectElement
                  getValue={getValues}
                  APIgetValue={
                    storeLicenseInfo
                      ? ownershipTypeList[
                          ownershipTypeList.findIndex(
                            (obj: any) =>
                              obj["license_type"] ===
                              storeLicenseInfo?.license_type
                          )
                        ]["name"]
                      : undefined
                  }
                  label="نوع مالکیت"
                  options={ownershipTypeList}
                  isRequired
                  getOptionLabel={(item) => item.name}
                  control={control}
                  name="license_type"
                  errors={errors.license_type}
                  showNonOption
                  defaultSelectValue="نوع مجوز خود را انتخاب نمایید"
                  mode="multiSelect"
                />

                <ControlledSelectElement
                  getValue={getValues}
                  APIgetValue={storeLicenseInfo?.job_category.name}
                  label="رسته صنفی"
                  options={jobCategoryList}
                  isRequired
                  getOptionLabel={(item) => item?.name}
                  control={control}
                  name="job_category_uid"
                  errors={errors?.job_category_uid}
                  showNonOption
                  defaultSelectValue="نوع رسته خود را انتخاب نمایید"
                  mode="multiSelect"
                />

                <InputComponent
                  defaultValue={storeLicenseInfo?.guild_id}
                  size="regular"
                  isRequired
                  label="شناسه صنفی"
                  name="guild_id"
                  control={control}
                  errors={errors?.guild_id}
                  maxLength={10}
                  svgIcon={
                    <img
                      src="/icons/shenase.svg"
                      alt="guildNumber icon"
                      width={16}
                    />
                  }
                />

                <InputComponent
                  defaultValue={
                    storeLicenseInfo?.isic_code !== null
                      ? storeLicenseInfo?.isic_code
                      : ""
                  }
                  size="regular"
                  label="کد آیسیک"
                  name="isic_code"
                  maxLength={15}
                  control={control}
                  errors={errors?.isic_code}
                  svgIcon={
                    <img
                      src="/icons/shenase.svg"
                      alt="AsickNumber icon"
                      width={16}
                    />
                  }
                />

                <>
                  <Controller
                    defaultValue={storeLicenseInfo?.date_of_issuance}
                    control={control}
                    name="date_of_issuance"
                    rules={{ required: true }}
                    render={({ field }) => {
                      return (
                        <LocalizationProvider
                          dateAdapter={AdapterDateFnsJalali}
                          dateFormats={{ monthShort: "MMMM" }}
                          localeText={{
                            fieldMonthPlaceholder: () => "ماه",
                            fieldDayPlaceholder: () => "روز",
                            fieldYearPlaceholder: () => "سال",
                          }}
                        >
                          <div className="flex flex-col mb-6">
                            <div className="flex">
                              <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                                تاریخ صدور
                              </label>
                              {<span className="text-red-500">*</span>}
                            </div>

                            <DatePicker
                              slots={{
                                openPickerIcon: CalenderIcon,
                              }}
                              disableFuture
                              onChange={(date) => {
                                field.onChange(date);
                              }}
                              defaultValue={
                                storeLicenseInfo?.date_of_issuance
                                  ? new Date(
                                      moment(
                                        storeLicenseInfo?.date_of_issuance,
                                        "jYYYY-jMM-jDD"
                                      ).format("YYYY-MM-DD")
                                    )
                                  : null
                              }
                              value={
                                storeLicenseInfo?.date_of_issuance
                                  ? new Date(storeLicenseInfo?.date_of_issuance)
                                  : null
                              }
                              closeOnSelect={true}
                              slotProps={{
                                inputAdornment: {
                                  position: "start",
                                },
                              }}
                              sx={{
                                svg: {
                                  color: errors?.date_of_issuance
                                    ? "#B91C1C"
                                    : "",
                                },
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  height: "44px",
                                  border: "none",
                                  borderRadius: "0.5rem",
                                },
                                "& .MuiDialogActions-root": {
                                  bgcolor: "#F9FAFB !important",
                                },
                                "& .MuiInputBase-root.Mui-focused": {
                                  bgcolor: "#F9FAFB !important",
                                },
                                "& .MuiInputBase-root": {
                                  bgcolor: errors?.date_of_issuance
                                    ? "#FEE2E2"
                                    : "#F9FAFB !important",
                                },
                                "& MuiInputBase-root-MuiOutlinedInput-root": {
                                  bgcolor: "red",
                                },
                              }}
                              className={`mb-0 ${
                                errors?.date_of_issuance
                                  ? "border-date-error "
                                  : ""
                              } `}
                              views={["year", "month", "day"]}
                              openTo="year"
                            />
                            {errors?.date_of_issuance ? (
                              <p
                                className={`text-Body-OneLine/14/Regular text-red-600`}
                              >
                                وارد کردن این مقدار الزامی است
                              </p>
                            ) : (
                              <div
                                className={`"flex items-center justify-center text-Body-OneLine/14/Regular text-gray-500"`}
                              ></div>
                            )}
                          </div>
                        </LocalizationProvider>
                      );
                    }}
                  />
                </>

                <>
                  <Controller
                    defaultValue={storeLicenseInfo?.expiry_date}
                    control={control}
                    name="expiry_date"
                    rules={{ required: true }}
                    render={({ field }) => {
                      return (
                        <LocalizationProvider
                          dateAdapter={AdapterDateFnsJalali}
                          dateFormats={{ monthShort: "MMMM" }}
                          localeText={{
                            fieldMonthPlaceholder: () => "ماه",
                            fieldDayPlaceholder: () => "روز",
                            fieldYearPlaceholder: () => "سال",
                          }}
                        >
                          <div className="flex flex-col gap-0 mb-6">
                            <div className="flex">
                              <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                                تاریخ انقضا
                              </label>
                              {<span className="text-red-500">*</span>}
                            </div>

                            <DatePicker
                              slots={{
                                openPickerIcon: CalenderIcon,
                              }}
                              disablePast
                              value={
                                storeLicenseInfo?.expiry_date
                                  ? new Date(storeLicenseInfo?.expiry_date)
                                  : null
                              }
                              onChange={(date) => {
                                field.onChange(date);
                              }}
                              closeOnSelect={true}
                              slotProps={{
                                inputAdornment: {
                                  position: "start",
                                },
                              }}
                              sx={{
                                svg: {
                                  color: errors?.expiry_date ? "#B91C1C" : "",
                                },
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  height: "44px",
                                  border: "none",
                                  borderRadius: "0.5rem",
                                },
                                "& .MuiDialogActions-root": {
                                  bgcolor: "#F9FAFB !important",
                                },
                                "& .MuiInputBase-root.Mui-focused": {
                                  bgcolor: "#F9FAFB !important",
                                },
                                "& .MuiInputBase-root": {
                                  bgcolor: errors?.expiry_date
                                    ? "#FEE2E2"
                                    : "#F9FAFB !important",
                                },
                                "& MuiInputBase-root-MuiOutlinedInput-root": {
                                  bgcolor: "red",
                                },
                              }}
                              className={`mb-0 ${
                                errors?.expiry_date ? "border-date-error " : ""
                              } `}
                              defaultValue={
                                storeLicenseInfo?.expiry_date
                                  ? new Date(
                                      moment(
                                        storeLicenseInfo?.expiry_date,
                                        "jYYYY-jMM-jDD"
                                      ).format("YYYY-MM-DD")
                                    )
                                  : null
                              }
                              views={["year", "month", "day"]}
                              openTo="year"
                            />
                            {errors?.expiry_date ? (
                              <p
                                className={`text-Body-OneLine/14/Regular text-red-600`}
                              >
                                وارد کردن این مقدار الزامی است
                              </p>
                            ) : (
                              <div
                                className={`"flex items-center justify-center text-Body-OneLine/14/Regular text-gray-500"`}
                              ></div>
                            )}
                          </div>
                        </LocalizationProvider>
                      );
                    }}
                  />
                </>
              </div>
            </div>
            <div className="basis-1/2 md:mr-10 max-sm:mr-2 sm:mr-2">
              <div className="flex flex-col mt-1">
                <label className="mb-2 text-Body-OneLine/14/Regular">
                  تصویر پروانه کسب
                  <span className="text-red-500">*</span>
                </label>
                <Controller
                  control={control}
                  name="license_image"
                  rules={{ required: true }}
                  render={({ field }) => {
                    return (
                      <UploderComponent
                        errors={errors.license_image}
                        defaultValue={imageData ? imageData : null}
                        onChange={(file: any) => {
                          field.onChange(file);
                        }}
                        isLoading={isImageDataLoading}
                        onRemove={() => {
                          setImageData(null);
                          setSendImageToApi(true);
                          field.onChange(null);
                        }}
                      />
                    );
                  }}
                />
              </div>

              <MultiSellectCheckboxCom
                APIgetValue={storeLicenseInfo?.product_group_uid_list}
                APIPath={`${BASE_URL_APP_VERSION}${STORE_PRODUCT_GROUP}`}
                withAPI={true}
                label="گروه محصول"
                isRequired
                control={control}
                uidName="product_group_uid"
                name="product_group_uid_list"
                errors={errors.product_group_uid_list}
                showNonOption
                defaultSelectValue="گروه های خود را انتخاب کنید"
                mode="withRadio"
                MarginTop
              />

              <p
                className={`mt-6 mb-2 ${
                  errors.nationalCodeTaxCode ? "text-red-500" : "text-gray-800"
                }  h-4`}
              >
                {"تکمیل کردن حداقل یکی از دو مورد زیر الزامی است:"}
                <span className="text-red-500">*</span>
              </p>
              <div
                className={`flex w-full p-0 flex-col items-start gap-2 shrink-0 border rounded-xl ${
                  errors.nationalCodeTaxCode ? "border-red-500" : ""
                } `}
              >
                <div className="w-full pr-8 pl-4 relative my-2">
                  <input
                    className="absolute inset-0 w-4 right-2"
                    type="radio"
                    checked={activeField === "national_code"}
                    onChange={() => handleRadioChange("national_code")}
                  />

                  <InputComponent
                    defaultValue={storeLicenseInfo?.national_code}
                    size="regular"
                    label="شناسه ملی"
                    name="national_code"
                    disabled={activeField !== "national_code"}
                    control={control}
                    errors={errors?.national_code}
                    maxLength={10}
                    svgIcon={
                      <img
                        src="/icons/shenase.svg"
                        alt="guildNumber icon"
                        width={16}
                      />
                    }
                  />
                </div>

                <div className="w-full pr-8 pl-4 relative my-2">
                  <input
                    type="radio"
                    className="absolute inset-0 w-4 right-2"
                    checked={activeField === "tax_code"}
                    onChange={() => handleRadioChange("tax_code")}
                  />

                  <InputComponent
                    defaultValue={storeLicenseInfo?.tax_code}
                    size="regular"
                    label="کد اقتصادی"
                    name="tax_code"
                    disabled={activeField !== "tax_code"}
                    control={control}
                    errors={errors?.tax_code}
                    maxLength={14}
                    svgIcon={
                      <img
                        src="/icons/shenase.svg"
                        alt="guildNumber icon"
                        width={16}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex w-full justify-center gap-1 pb-4 sticky bottom-0 bg-white right-0 left-0">
            <ButtonComponent
              type="button"
              className="mt-8 w-[120px] h-10"
              variant="outlined"
              onClick={() => setFormNo(formNo - 1)}
            >
              بازگشت
            </ButtonComponent>
            <ButtonComponent
              type="submit"
              className="mt-8 w-[120px] h-10"
              variant="filled"
              isClicked={isSubmiting}
              disabled={isSubmiting}
            >
              ادامه
            </ButtonComponent>
          </div>
        </motion.form>
      )}
    </>
  );
}

export default SellerFormStep3;
